import React, { useCallback } from "react";
import { ServiceProvider } from "../../../../../domain/service_provider/ServiceProvider";
import { Paths } from "../../../../../Paths";
import { useServiceProviderList } from "../../../../hooks/admin/service_provider/useServiceProviderList";
import { Button } from "../../../common/button/Button";
import { Loading } from "../../../common/Loading";
import { NoData } from "../../../common/no_data/NoData";
import { useNavigate } from "react-router-dom";

export const ServiceProviderList = React.memo(function ServiceProviderList() {
    const navigate = useNavigate();

    const serviceProviderList = useServiceProviderList();

    const handleServiceProviderEditClicked = useCallback((serviceProvider: ServiceProvider) => () =>
        navigate(`${Paths.admin}${Paths.serviceProvider}${Paths.edit}/${serviceProvider.id.value}`)
    , [history]);

    return (
        <>
            {/* レスポンス取得中：ローディング表示 */}
            {/* データ0件：データ無し表示 */}
            {/* 上記以外：リスト表示 */}
            {!serviceProviderList ? (
                <Loading />
            ) : !serviceProviderList.length ? (
                <NoData />
            ) : (
                <>
                    {serviceProviderList.map((serviceProvider) => (
                        <li key={serviceProvider.id.value} className={"list_row"}>
                            <div>{serviceProvider.name.value}</div>
                            <Button label={"編集"} colorReversed={true} onClick={handleServiceProviderEditClicked(serviceProvider)} />
                        </li>
                    ))}
                </>
            )}
        </>
    );
});
